module.exports = __webpack_public_path__ + "static/img_2549-5c4919ed9ac4749c50a54c316f08dd3d.webp";